import {ROUTES} from '../../../app.routes';
import {MenuExternal, MenuItem} from './menu-item';

const SECURE = ROUTES.SECURE;
const ECOMMERCE_TRANSACTIONS = SECURE.ACCOUNT.ECOMMERCE;

const GATEWAY_SERVICE_TERMS: MenuExternal = {
    kind: 'external',
    label: 'Pay@ Gateway Merchant Terms',
    href: 'env:gatewayMerchantTermsLink',
    target: '_blank'
};

export const GO_MENU: MenuItem[] = [
    {
        kind: 'link',
        label: 'Home',
        icon: 'fas fa-home',
        route: SECURE.ECOMMERCE.LANDING,
        exact: true,
        hidden: (ctx) => !ctx.showEcommerceLanding
    },
    {
        kind: 'group',
        label: 'Account Details',
        icon: 'fas fa-address-card',
        collapseKey: 'account',
        children: [
            {
                kind: 'link',
                label: 'Account Settings',
                icon: 'fas fa-cogs',
                route: SECURE.BUSINESS.EDIT,
                hidden: (ctx) => ctx.isAccountSettingsHidden
            },
            {
                kind: 'link',
                label: 'Users',
                icon: 'fas fa-user-edit',
                route: SECURE.USER.LIST,
                exact: true,
                hidden: (ctx) => ctx.showEcommerceLanding
            },
            {
                kind: 'link',
                label: 'User Invitations',
                icon: 'fas fa-user-plus',
                route: SECURE.USER.INVITATION.LIST,
                hidden: (ctx) => ctx.showEcommerceLanding
            },
            {
                kind: 'link',
                label: 'Invoices',
                icon: 'fas fa-file-alt',
                route: SECURE.INVOICES.LIST,
                hidden: (ctx) => ctx.showEcommerceLanding
            }
        ]
    },
    {
        kind: 'group',
        label: 'Bill Pay',
        icon: 'fas fa-file-invoice-dollar',
        collapseKey: 'individual',
        hidden: (ctx) => ctx.showEcommerceLanding,
        children: [
            {
                kind: 'link',
                label: 'Quick Pay',
                icon: 'fas fa-bolt',
                route: SECURE.ACCOUNT.QUICK_PAY_CREATE,
                exact: true,
                extraPrivileges: [SECURE.ACCOUNT.READONLY_CREATE.privilege]
            },
            {
                kind: 'link',
                label: 'Create Invoice',
                icon: 'fas fa-money-check-alt',
                route: SECURE.ACCOUNT.CREATE,
                exact: true,
                extraPrivileges: [SECURE.ACCOUNT.READONLY_CREATE.privilege]
            },
            {
                kind: 'link',
                label: 'Upload Bulk File',
                icon: 'fas fa-file-import',
                route: SECURE.ACCOUNT.UPLOAD_REQUESTS_FILE,
                exact: true,
                extraPrivileges: [SECURE.ACCOUNT.READONLY_UPLOAD_REQUESTS_FILE.privilege],
                hidden: (ctx) => !ctx.isBulkEnabled
            },
            {
                kind: 'link',
                label: 'Create QR Code',
                icon: 'fas fa-qrcode',
                route: SECURE.QR.CREATE,
                exact: true,
                hidden: (ctx) => !ctx.isQrCodesEnabled
            },
            {kind: 'divider'},
            {
                kind: 'link',
                label: 'Transactions',
                icon: 'fas fa-receipt',
                route: SECURE.ACCOUNT.LIST,
                exact: true
            },
            {
                kind: 'link',
                label: 'Bulk',
                icon: 'pi pi-list',
                route: SECURE.ACCOUNT.BULK,
                exact: true
            },
            {
                kind: 'link',
                label: 'QR Codes',
                icon: 'fas fa-solid fa-qrcode',
                route: SECURE.QR.LIST,
                exact: true,
                hidden: (ctx) => !ctx.isQrCodesEnabled
            },
            {
                kind: 'link',
                label: 'QR Payments',
                icon: 'pi pi-qrcode',
                route: SECURE.QR.PAYMENTS,
                exact: true
            },
            {
                kind: 'link',
                label: 'Purchase',
                icon: 'fa fa-shopping-bag',
                route: SECURE.PURCHASE.MESSAGE_BUNDLES,
                badgeIndicator: 'signupFeeUnpaid'
            },
            {kind: 'divider'},
            {
                kind: 'external',
                label: 'Pay@Go Service Terms',
                icon: 'fas fa-file-pdf',
                href: 'env:serviceTermsLink',
                target: '_blank'
            }
        ]
    },
    {
        kind: 'group',
        label: 'E-Commerce',
        icon: 'fas fa-shopping-cart',
        collapseKey: 'ecommerce',
        hidden: (ctx) => !ctx.env.eCommerceEnabled || !ctx.isEcommerceMerchant || ctx.showEcommerceLanding,
        children: [
            {
                kind: 'link',
                label: 'Dashboard',
                icon: 'fas fa-chart-line',
                route: SECURE.ACCOUNT.ECOMMERCE_DASHBOARD,
                exact: true
            },
            {
                kind: 'link',
                label: 'Refund Monitoring',
                icon: 'fa-solid fa-money-bill-trend-up',
                route: SECURE.ACCOUNT.REFUND_DASHBOARD,
                exact: true
            },
            {kind: 'link', label: 'Transactions', icon: 'fas fa-receipt', route: ECOMMERCE_TRANSACTIONS, exact: true},
            {
                kind: 'link',
                label: 'Refund Transactions',
                icon: 'fas fa-undo',
                route: SECURE.ACCOUNT.REFUND_TRANSACTIONS,
                exact: true
            },
            {
                kind: 'link',
                label: 'Float Monitoring',
                icon: 'fas fa-coins',
                route: SECURE.ACCOUNT.ECOMMERCE_FLOAT_MONITORING,
                exact: true
            },
            {kind: 'divider'},
            {...GATEWAY_SERVICE_TERMS, icon: 'fas fa-file-pdf'}
        ]
    },
    {
        kind: 'link',
        label: 'Settlement',
        icon: 'fas fa-receipt',
        route: SECURE.SETTLEMENT_BATCH.LIST,
        hidden: (ctx) => ctx.showEcommerceLanding
    },
    {kind: 'external', label: 'Get Help', icon: 'fas side-menu-fa-question-circle fa-question-circle', onClick: 'help'},
    {
        kind: 'group',
        label: 'Legal',
        icon: 'fas fa-file-pdf',
        collapseKey: 'legal',
        children: [
            {...GATEWAY_SERVICE_TERMS, hidden: (ctx) => !ctx.showEcommerceLanding},
            {kind: 'external', label: 'General Terms', href: 'env:generalTermsLink', target: '_blank'},
            {kind: 'external', label: 'Privacy Policy', href: 'env:privacyNoticeLink', target: '_blank'}
        ]
    },
    {kind: 'link', label: 'FAQ', icon: 'fas fa-info-circle', route: ROUTES.PUBLIC.FAQS, target: '_blank'},
    {kind: 'external', label: 'Sign Out', icon: 'fas fa-sign-out', onClick: 'logout'}
];
